import React, { useEffect, useState } from "react";

const ContentPreviewer = ({ width, height, data, type }) => {
  if (!data) return <div></div>;
  return (
    data &&
    data[0] && (
      <div className={{ width: "100%" }}>
        <object
          // data="https://res.cloudinary.com/cloudinaryforme/image/upload/v1618339571/workplace-1245776_1920_i9ayae.jpg"
          data={data}
          width="700px"
          height="500px"
        >
          <iframe
            // src="https://res.cloudinary.com/cloudinaryforme/image/upload/v1618339571/workplace-1245776_1920_i9ayae.jpg"
            data={data}
            width="900px"
            height="700px"
          >
            <p>This browser does not support PDF!</p>
          </iframe>
        </object>
      </div>
    )
  );
};

export default ContentPreviewer;
